import { render, staticRenderFns } from "./PaypalPayment.vue?vue&type=template&id=4975e442&scoped=true"
import script from "./PaypalPayment.vue?vue&type=script&lang=js"
export * from "./PaypalPayment.vue?vue&type=script&lang=js"
import style0 from "./PaypalPayment.vue?vue&type=style&index=0&id=4975e442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975e442",
  null
  
)

export default component.exports